import React from 'react';

import './status-span.scss';

// finish off with the different types
export const STATUS_TYPE = {
  active: 'Active',
  declined: 'Declined',
  '00': 'Approved',
  '05': 'Do not honour',
};

export default function StatusSpan(props) {
  let color, backgroundColor;

  switch ((props.status || '').toLowerCase()) {
    case 'active':
      color = '#00B0CA';
      backgroundColor = 'rgba(0, 176, 202, 0.2)';
      break;
    case 'declined':
      color = '#EB9700';
      backgroundColor = 'rgba(235, 151, 0, 0.4)';
      break;
    case 'approved':
      color = '#27AE60';
      backgroundColor = 'rgba(39, 174, 96, 0.2)';
      break;
    case 'do not honour':
      color = '#EB9700';
      backgroundColor = 'rgba(235, 151, 0, 0.4)';
      break;
    default:
      color = '#D8DBE0';
      backgroundColor = 'rgba(216, 219, 224, 0.4)';
      break;
  }
  return (
    <div
      className={`status-container ${props.className || ''}`}
      style={{ backgroundColor: backgroundColor }}
      data-testid="status-span"
    >
      <span className="status-dot" style={{ backgroundColor: color }}></span>
      <span className="status-text" style={{ color: color }} data-testid="status-span-text">
        {props.status ? props.status : 'Unknown'}
      </span>
    </div>
  );
}
